import { memo } from "react";
import { withNamespaces } from "react-i18next";
import { Handle, Position } from "react-flow-renderer";
import { UncontrolledTooltip } from "reactstrap";

const DataFlowNode = ({ t, id, data }) => {
    const { label, caption, variant, side, icon, tooltip } = data || {};
    const tooltipId = `data-flow-node-${id}`;
    const handleSide = side || variant;

    return (
        <>
            <div
                id={tooltip ? tooltipId : undefined}
                className={`software-flow-node software-flow-node--${variant}`}
            >
                <span className="software-flow-node__icon">
                    <i className={icon} aria-hidden="true" />
                </span>
                <span className="software-flow-node__body">
                    <strong className="software-flow-node__title">
                        {label}
                    </strong>
                    {caption && (
                        <small className="software-flow-node__caption">
                            {t(caption)}
                        </small>
                    )}
                </span>

                {handleSide !== "incoming" && (
                    <Handle
                        type="target"
                        position={Position.Left}
                        isConnectable={false}
                    />
                )}
                {handleSide !== "outgoing" && (
                    <Handle
                        type="source"
                        position={Position.Right}
                        isConnectable={false}
                    />
                )}
            </div>

            {tooltip && (
                <UncontrolledTooltip target={tooltipId} placement="top">
                    {tooltip}
                </UncontrolledTooltip>
            )}
        </>
    );
};

export default withNamespaces()(memo(DataFlowNode));
